<template>
  <div :class="[$style[theme], $style.giphy]">
    <img
      :src="url"
      :width="dimensions.width"
      :height="dimensions.height"
      :alt="alt"
      loading="lazy"
      :class="$style.img"
      @load="loading = false"
      @error="error = true"
    />
    <img
      :src="urlPreview"
      :width="dimensions.width"
      :height="dimensions.height"
      :alt="alt"
      :class="[$style.imgPreview, { [$style.hide]: show }]"
      loading="eager"
    />
  </div>
</template>

<script>
const HEIGHT_LIMIT = 300

export default {
  name: 'message-content-giphy',
  props: {
    message: {
      type: Object,
      required: true
    },
    theme: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: true,
    error: false
  }),
  computed: {
    show () {
      return !this.loading && !this.error
    },
    alt () {
      return this.giphy?.title ?? this.$t('messageType.giphy')
    },
    dimensions () {
      const box = this.giphy?.images.downsized ?? {
        width: 100,
        height: 100
      }
      if (box.height > HEIGHT_LIMIT) {
        const k = HEIGHT_LIMIT / box.height
        box.height *= k
        box.width *= k
      }
      return box
    },
    url () {
      return this.giphy?.images.downsized.url
    },
    urlPreview () {
      return this.giphy?.images.preview_gif.url
    },
    giphyId () {
      return this.message.payload.giphyId
    },
    giphy () {
      return this.$store.getters['giphy/find'](this.giphyId)
    }
  },
  watch: {
    url (val) {
      if (!val) return
      this.loading = true
      this.error = false
    },
    giphyId: {
      immediate: true,
      handler: 'getGif'
    }
  },
  methods: {
    async getGif (giphyId) {
      if (!giphyId || this.giphy) return
      await this.$store.dispatch('giphy/getById', giphyId)
    }
  }
}
</script>

<style module lang="scss">
.green {
}
.giphy {
  font-size: 0;
  position: relative;
}
.img {
  max-height: 300px;
  object-fit: contain;
  width: min-content;
}
.imgPreview {
  left: 0;
  max-height: 300px;
  max-width: 100%;
  object-fit: cover;
  object-position: center;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 10;
}
.hide {
  z-index: -1;
}
</style>
